export const S3Cdn = {
  files: "https://cdn.bhaptics.com/files",
} as const;
